import React, { forwardRef } from "react"
import { makeStyles } from "@material-ui/styles"
import { Box } from "@material-ui/core"
import ErrorBoundary from "../ErrorBoundary/ErrorBoundary"
import OfflineModeBanner from "../Offline/OfflineModeBanner"

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    fontSize: 20,
    fontWeight: "600 !important",
    lineHeight: "28px",
    paddingRight: theme.spacing(5)
  }
}))

const InlineTitle = forwardRef(function InlineTitle({ children, boxProps, className }, ref) {
  const classes = useStyles()

  return (
    <div ref={ref} className={className}>
      <ErrorBoundary>
        <OfflineModeBanner />
        <Box className={classes.root} display="flex" alignItems="center" mx={2} {...boxProps}>
          {children}
        </Box>
      </ErrorBoundary>
    </div>
  )
})

export { InlineTitle }
